import React, { useState, useEffect } from 'react'
import palette from 'src/designSystem/variables/palette'
import Dropdown from 'react-bootstrap/Dropdown'
import { PillOption } from './Pill.constants'
import { DarkenColor } from './Pill.helper'
import { PillContainer, PillSelectionContainer } from './Pill.styles'

export interface PillSelectionProps {
  initialSelectedOption?: PillOption | null
  options: PillOption[]
  onSelectionChange: (selected: PillOption | null) => void
  allowEmptySelection?: boolean
  $width?: string
  $height?: string
  renderLabel?: (option: PillOption | null) => React.ReactNode
}

export const PillSelection = ({
  options,
  onSelectionChange,
  initialSelectedOption,
  allowEmptySelection = false,
  $width = 'fit-content',
  $height = 'fit-content',
  renderLabel,
}: PillSelectionProps): JSX.Element => {
  const [selectedOption, setSelectedOption] = useState<PillOption | null>(
    initialSelectedOption || null,
  )

  useEffect(() => {
    setSelectedOption(initialSelectedOption || null)
  }, [initialSelectedOption])

  const handlePillClick = (option: PillOption | null) => {
    setSelectedOption(option)
    onSelectionChange(option)
  }

  return (
    <Dropdown
      style={{ width: $width, height: $height }}
      onClick={(event) => {
        event.stopPropagation()
        event.preventDefault()
      }}
    >
      <Dropdown.Toggle
        as={PillSelectionContainer}
        style={{
          width: $width,
          height: $height,
          backgroundColor: selectedOption
            ? selectedOption.color
            : palette.neutral[100],
          border: `2px solid ${
            selectedOption
              ? DarkenColor(selectedOption.color, 30)
              : palette.neutral[200]
          }`,
        }}
      >
        {renderLabel
          ? renderLabel(selectedOption)
          : selectedOption
          ? selectedOption.name
          : 'Select an option'}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {allowEmptySelection && (
          <Dropdown.Item
            key="clear-selection"
            onClick={() => handlePillClick(null)}
          >
            Clear selection
          </Dropdown.Item>
        )}
        {options.map((option) => (
          <Dropdown.Item
            key={option.name}
            onClick={() => handlePillClick(option)}
          >
            <PillContainer
              key={option.name}
              style={{
                backgroundColor: option.color,
                cursor: 'pointer',
                height: '40px',
                width: '100%',
              }}
              onClick={() => {
                handlePillClick(option)
              }}
            >
              {renderLabel ? renderLabel(option) : <span>{option.name}</span>}
            </PillContainer>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
